import { toast } from "react-toastify";
import { apiSlice } from ".";

const RolesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => `/RoleTables/GetRoleTables`,
    }),
    getAllRolesForTable: builder.query({
      query: ({agcId}) => `/TableRights/GetTableRights?agencyid=${agcId}`,
    }),
    postRole: builder.mutation({
      query: (data) => ({
        url: "/TableRights/PostTableRight",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Assigning Role",
          success: "Role Has Been Assign",
          error: "Error Assigning Role",
        });
      },
    }),
    updateRole: builder.mutation({
      query: ({id, data}) => ({
        url: `/TableRights/PutTableRight/${id}`,
        method: "PUT",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Updating Role",
          success: "Role Has Been Updated",
          error: "Error Updating Role",
        });
      },
    }),
  }),
});

export const { useGetRolesQuery, usePostRoleMutation, useUpdateRoleMutation, useGetAllRolesForTableQuery } = RolesApi;
